module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Reasons")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('h1', {
    staticClass: "title1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("to")])]), _vm._v(" "), _c('h1', {
    staticClass: "title2"
  }, [_vm._v("Live")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("An Interactive Guide to Healing and Overcoming Suicidal Thoughts and How to Help Others Survive")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("Juliana J Bruno, a.k.a. Juliana Jay")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ced84028","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/01_Title.vue
// module id = 60
// module chunks = 0